// src/utils/msal.js
export function getMsal() {
  const inst = window.__msalInstance;
  if (!inst) {
    throw new Error("MSAL not ready yet. Make sure index.js finished bootstrap.");
  }
  return inst;
}